module.exports = __webpack_public_path__ + "static/media/wizualizacja-59.c91ce4bf.png";